import { render, staticRenderFns } from "./delModal.vue?vue&type=template&id=2607a687"
import script from "./delModal.vue?vue&type=script&lang=js"
export * from "./delModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports